// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Confirm_wrapper__2hjIU","root":"Confirm_root__ilpJC","authHead":"Confirm_authHead__2eVnD","authTitle":"Confirm_authTitle__14mcY","formItem":"Confirm_formItem__1omX3"};